// extracted by mini-css-extract-plugin
module.exports = {"titlePopUp":"styles_titlePopUp__3748P","tableWrap":"styles_tableWrap__NLQBD","table":"styles_table__3MfWS"};